export enum ObjectTemplateGenerationEnum {
  DOCX = 'docx',
  PDF = 'pdf',
}
